import ActionConstants from '../constants';

const initialState = {
  // Submit Force Refund Request
  submitForceRefundRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Force Refund Requests
  getForceRefundRequestsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Force Refund Request Details
  getForceRefundRequestDetailsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Approve Force Refund Request
  approveForceRefundRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Reject Force Refund Request
  rejectForceRefundRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Force Refund Execution Status
  getForceRefundExecutionStatusState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Submit Force Update Order Request
  submitForceUpdateOrderRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Force Update Order Requests
  getForceUpdateOrderRequestsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Get Force Update Order Request Details
  getForceUpdateOrderRequestDetailsState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Approve Force Update Order Request
  approveForceUpdateOrderRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Reject Force Update Order Request
  rejectForceUpdateOrderRequestState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },

  // Force Update Order Execution Status
  getForceUpdateOrderExecutionStatusState: {
    loading: false,
    success: false,
    failure: false,
    data: null,
    error: null,
  },
};

const makerCheckerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Submit Force Refund Request
    case ActionConstants.SUBMIT_FORCE_REFUND_REQUEST_REQUEST:
      return {
        ...state,
        submitForceRefundRequestState: {
          ...state.submitForceRefundRequestState,
          loading: true,
          success: false,
          failure: false,
          error: null,
        },
      };

    case ActionConstants.SUBMIT_FORCE_REFUND_REQUEST_SUCCESS:
      return {
        ...state,
        submitForceRefundRequestState: {
          ...state.submitForceRefundRequestState,
          loading: false,
          success: true,
          failure: false,
          data: action.payload,
          error: null,
        },
      };

    case ActionConstants.SUBMIT_FORCE_REFUND_REQUEST_FAILURE:
      return {
        ...state,
        submitForceRefundRequestState: {
          ...state.submitForceRefundRequestState,
          loading: false,
          success: false,
          failure: true,
          data: null,
          error: action.payload,
        },
      };

    case ActionConstants.SUBMIT_FORCE_REFUND_REQUEST_CLEAR:
      return {
        ...state,
        submitForceRefundRequestState: {
          ...initialState.submitForceRefundRequestState,
        },
      };

    // Get Force Refund Requests
    case ActionConstants.GET_FORCE_REFUND_REQUESTS_REQUEST:
      return {
        ...state,
        getForceRefundRequestsState: {
          ...state.getForceRefundRequestsState,
          loading: true,
          success: false,
          failure: false,
          error: null,
        },
      };

    case ActionConstants.GET_FORCE_REFUND_REQUESTS_SUCCESS:
      return {
        ...state,
        getForceRefundRequestsState: {
          ...state.getForceRefundRequestsState,
          loading: false,
          success: true,
          failure: false,
          data: action.payload,
          error: null,
        },
      };

    case ActionConstants.GET_FORCE_REFUND_REQUESTS_FAILURE:
      return {
        ...state,
        getForceRefundRequestsState: {
          ...state.getForceRefundRequestsState,
          loading: false,
          success: false,
          failure: true,
          data: null,
          error: action.payload,
        },
      };

    case ActionConstants.GET_FORCE_REFUND_REQUESTS_CLEAR:
      return {
        ...state,
        getForceRefundRequestsState: {
          ...initialState.getForceRefundRequestsState,
        },
      };

    // Get Force Refund Request Details
    case ActionConstants.GET_FORCE_REFUND_REQUEST_DETAILS_REQUEST:
      return {
        ...state,
        getForceRefundRequestDetailsState: {
          ...state.getForceRefundRequestDetailsState,
          loading: true,
          success: false,
          failure: false,
          error: null,
        },
      };

    case ActionConstants.GET_FORCE_REFUND_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        getForceRefundRequestDetailsState: {
          ...state.getForceRefundRequestDetailsState,
          loading: false,
          success: true,
          failure: false,
          data: action.payload,
          error: null,
        },
      };

    case ActionConstants.GET_FORCE_REFUND_REQUEST_DETAILS_FAILURE:
      return {
        ...state,
        getForceRefundRequestDetailsState: {
          ...state.getForceRefundRequestDetailsState,
          loading: false,
          success: false,
          failure: true,
          data: null,
          error: action.payload,
        },
      };

    case ActionConstants.GET_FORCE_REFUND_REQUEST_DETAILS_CLEAR:
      return {
        ...state,
        getForceRefundRequestDetailsState: {
          ...initialState.getForceRefundRequestDetailsState,
        },
      };

    // Approve Force Refund Request
    case ActionConstants.APPROVE_FORCE_REFUND_REQUEST_REQUEST:
      return {
        ...state,
        approveForceRefundRequestState: {
          ...state.approveForceRefundRequestState,
          loading: true,
          success: false,
          failure: false,
          error: null,
        },
      };

    case ActionConstants.APPROVE_FORCE_REFUND_REQUEST_SUCCESS:
      return {
        ...state,
        approveForceRefundRequestState: {
          ...state.approveForceRefundRequestState,
          loading: false,
          success: true,
          failure: false,
          data: action.payload,
          error: null,
        },
      };

    case ActionConstants.APPROVE_FORCE_REFUND_REQUEST_FAILURE:
      return {
        ...state,
        approveForceRefundRequestState: {
          ...state.approveForceRefundRequestState,
          loading: false,
          success: false,
          failure: true,
          data: null,
          error: action.payload,
        },
      };

    case ActionConstants.APPROVE_FORCE_REFUND_REQUEST_CLEAR:
      return {
        ...state,
        approveForceRefundRequestState: {
          ...initialState.approveForceRefundRequestState,
        },
      };

    // Reject Force Refund Request
    case ActionConstants.REJECT_FORCE_REFUND_REQUEST_REQUEST:
      return {
        ...state,
        rejectForceRefundRequestState: {
          ...state.rejectForceRefundRequestState,
          loading: true,
          success: false,
          failure: false,
          error: null,
        },
      };

    case ActionConstants.REJECT_FORCE_REFUND_REQUEST_SUCCESS:
      return {
        ...state,
        rejectForceRefundRequestState: {
          ...state.rejectForceRefundRequestState,
          loading: false,
          success: true,
          failure: false,
          data: action.payload,
          error: null,
        },
      };

    case ActionConstants.REJECT_FORCE_REFUND_REQUEST_FAILURE:
      return {
        ...state,
        rejectForceRefundRequestState: {
          ...state.rejectForceRefundRequestState,
          loading: false,
          success: false,
          failure: true,
          data: null,
          error: action.payload,
        },
      };

    case ActionConstants.REJECT_FORCE_REFUND_REQUEST_CLEAR:
      return {
        ...state,
        rejectForceRefundRequestState: {
          ...initialState.rejectForceRefundRequestState,
        },
      };

    // Force Refund Execution Status
    case ActionConstants.GET_FORCE_REFUND_EXECUTION_STATUS_REQUEST:
      return { ...state, getForceRefundExecutionStatusState: { ...state.getForceRefundExecutionStatusState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FORCE_REFUND_EXECUTION_STATUS_SUCCESS:
      return { ...state, getForceRefundExecutionStatusState: { ...state.getForceRefundExecutionStatusState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FORCE_REFUND_EXECUTION_STATUS_FAILURE:
      return { ...state, getForceRefundExecutionStatusState: { ...state.getForceRefundExecutionStatusState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FORCE_REFUND_EXECUTION_STATUS_CLEAR:
      return { ...state, getForceRefundExecutionStatusState: { ...initialState.getForceRefundExecutionStatusState } };
    // Submit Force Update Order Request
    case ActionConstants.SUBMIT_FORCE_UPDATE_ORDER_REQUEST_REQUEST:
      return { ...state, submitForceUpdateOrderRequestState: { ...state.submitForceUpdateOrderRequestState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.SUBMIT_FORCE_UPDATE_ORDER_REQUEST_SUCCESS:
      return { ...state, submitForceUpdateOrderRequestState: { ...state.submitForceUpdateOrderRequestState, loading: false, success: true, failure: false, data: action.payload, error: null } };
    case ActionConstants.SUBMIT_FORCE_UPDATE_ORDER_REQUEST_FAILURE:
      return { ...state, submitForceUpdateOrderRequestState: { ...state.submitForceUpdateOrderRequestState, loading: false, success: false, failure: true, data: null, error: action.payload } };
    case ActionConstants.SUBMIT_FORCE_UPDATE_ORDER_REQUEST_CLEAR:
      return { ...state, submitForceUpdateOrderRequestState: { ...initialState.submitForceUpdateOrderRequestState } };

    // Get Force Update Order Requests
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUESTS_REQUEST:
      return { ...state, getForceUpdateOrderRequestsState: { ...state.getForceUpdateOrderRequestsState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUESTS_SUCCESS:
      return { ...state, getForceUpdateOrderRequestsState: { ...state.getForceUpdateOrderRequestsState, loading: false, success: true, failure: false, data: action.payload, error: null } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUESTS_FAILURE:
      return { ...state, getForceUpdateOrderRequestsState: { ...state.getForceUpdateOrderRequestsState, loading: false, success: false, failure: true, data: null, error: action.payload } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUESTS_CLEAR:
      return { ...state, getForceUpdateOrderRequestsState: { ...initialState.getForceUpdateOrderRequestsState } };

    // Get Force Update Order Request Details
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_REQUEST:
      return { ...state, getForceUpdateOrderRequestDetailsState: { ...state.getForceUpdateOrderRequestDetailsState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_SUCCESS:
      return { ...state, getForceUpdateOrderRequestDetailsState: { ...state.getForceUpdateOrderRequestDetailsState, loading: false, success: true, failure: false, data: action.payload, error: null } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_FAILURE:
      return { ...state, getForceUpdateOrderRequestDetailsState: { ...state.getForceUpdateOrderRequestDetailsState, loading: false, success: false, failure: true, data: null, error: action.payload } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS_CLEAR:
      return { ...state, getForceUpdateOrderRequestDetailsState: { ...initialState.getForceUpdateOrderRequestDetailsState } };

    // Approve Force Update Order Request
    case ActionConstants.APPROVE_FORCE_UPDATE_ORDER_REQUEST_REQUEST:
      return { ...state, approveForceUpdateOrderRequestState: { ...state.approveForceUpdateOrderRequestState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.APPROVE_FORCE_UPDATE_ORDER_REQUEST_SUCCESS:
      return { ...state, approveForceUpdateOrderRequestState: { ...state.approveForceUpdateOrderRequestState, loading: false, success: true, failure: false, data: action.payload, error: null } };
    case ActionConstants.APPROVE_FORCE_UPDATE_ORDER_REQUEST_FAILURE:
      return { ...state, approveForceUpdateOrderRequestState: { ...state.approveForceUpdateOrderRequestState, loading: false, success: false, failure: true, data: null, error: action.payload } };
    case ActionConstants.APPROVE_FORCE_UPDATE_ORDER_REQUEST_CLEAR:
      return { ...state, approveForceUpdateOrderRequestState: { ...initialState.approveForceUpdateOrderRequestState } };

    // Reject Force Update Order Request
    case ActionConstants.REJECT_FORCE_UPDATE_ORDER_REQUEST_REQUEST:
      return { ...state, rejectForceUpdateOrderRequestState: { ...state.rejectForceUpdateOrderRequestState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.REJECT_FORCE_UPDATE_ORDER_REQUEST_SUCCESS:
      return { ...state, rejectForceUpdateOrderRequestState: { ...state.rejectForceUpdateOrderRequestState, loading: false, success: true, failure: false, data: action.payload, error: null } };
    case ActionConstants.REJECT_FORCE_UPDATE_ORDER_REQUEST_FAILURE:
      return { ...state, rejectForceUpdateOrderRequestState: { ...state.rejectForceUpdateOrderRequestState, loading: false, success: false, failure: true, data: null, error: action.payload } };
    case ActionConstants.REJECT_FORCE_UPDATE_ORDER_REQUEST_CLEAR:
      return { ...state, rejectForceUpdateOrderRequestState: { ...initialState.rejectForceUpdateOrderRequestState } };

    // Force Update Order Execution Status
    case ActionConstants.GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_REQUEST:
      return { ...state, getForceUpdateOrderExecutionStatusState: { ...state.getForceUpdateOrderExecutionStatusState, loading: true, success: false, failure: false, error: null } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_SUCCESS:
      return { ...state, getForceUpdateOrderExecutionStatusState: { ...state.getForceUpdateOrderExecutionStatusState, loading: false, success: true, failure: false, data: action.payload?.body, error: null } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_FAILURE:
      return { ...state, getForceUpdateOrderExecutionStatusState: { ...state.getForceUpdateOrderExecutionStatusState, loading: false, success: false, failure: true, data: null, error: action.payload?.body } };
    case ActionConstants.GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS_CLEAR:
      return { ...state, getForceUpdateOrderExecutionStatusState: { ...initialState.getForceUpdateOrderExecutionStatusState } };

    default:
      return state;
  }
};

export default makerCheckerReducer;
